import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'

export function useDontDisturbBottomSheet() {
  const { privacyCenterContent, isAppLoading, isAppError } = useAppContext()

  const content = privacyCenterContent?.components?.dontDisturbBottomsheet?.content

  const isErrorOrInactive =
    isAppError ||
    isEmpty(content) ||
    !privacyCenterContent?.components?.dontDisturbBottomsheet?.isActive

  return { content, isErrorOrInactive, isAppLoading }
}
